<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <div>
          <b-card-title class="mb-1">
            Produk Registry Baru
          </b-card-title>
        </div>
      </b-card-header>

      <b-card-body>
        <vue-apex-charts
          type="area"
          height="300"
          :options="chartOptions"
          :series="chartData"
        />
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BCardTitle,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    BCard,
    VueApexCharts,
    BCardHeader,
    BCardBody,
    BCardTitle,
  },
  props: {
    data: {
      type: Array,
      default: () => ([]),
    },
    chartOption: {
      type: Object,
      default: () => ({}),
    },
    labelYaxis: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    totalProducts() {
      return this.data.reduce((total, el) => total + el.all_product_registry_count, 0)
    },
    chartData() {
      return [
        {
          name: 'Semua',
          data: this.data.map(el => el.all_product_registry_count),
        },
        {
          name: 'Internal',
          data: this.data.map(el => el.internal_product_registry_count),
        },
        {
          name: 'Eksternal',
          data: this.data.map(el => el.external_product_registry_count),
        },
      ]
    },
    chartOptions() {
      return {
        ...this.chartOption,
        xaxis: {
          categories: this.data.map(el => this.formatSelectDate(el.date, ['month', 'year'])),
        },
        ...this.labelYaxis,
      }
    },
  },
}
</script>
